import axios from "axios";

export const sendClick = (type: string) => {
  const url = `/dishaAPI/bot/clicks/${type}`;
  axios.put(url).catch((_) => console.log("Failed to record clicks:", _));
};
